<script lang="ts" setup>
	import {Save} from 'lucide-vue-next';
	import FormProject from './form-project.vue';
	import {TypedSchema, useForm} from 'vee-validate';
	import {InitiateProjectRequest} from '@/scripts/types/generated';
	import {toTypedSchema} from '@vee-validate/zod';
	import {z} from 'zod';

	const isOpen = defineModel<boolean>();

	const {createProject} = useProjects();

	const formSchema: TypedSchema<InitiateProjectRequest> = toTypedSchema(
		z.object({
			processVersionUuid: z.string().uuid(),
			clientUuid: z.string().uuid(),
			name: z.string(),
		})
	);

	const form = useForm({
		validationSchema: formSchema,
	});

	const onSubmit = form.handleSubmit(async (values) => {
		await createProject(values)
			.then(() => {
				isOpen.value = false;
			})
			.catch((errors) => {
				form.setErrors(errors);
			});
	});
</script>

<template>
	<DialogContent>
		<DialogHeader>
			<DialogTitle
				>{{ $t('domains.tenant.project.create.title') }}
			</DialogTitle>
			<DialogDescription
				>{{ $t('domains.tenant.project.create.description') }}
			</DialogDescription>
		</DialogHeader>
		<form @submit.prevent="onSubmit">
			<FormProject />
		</form>
		<DialogFooter>
			<ButtonForm
				:loading="form.isSubmitting.value"
				type="submit"
				@click="onSubmit"
			>
				<template #icon>
					<Save class="h-6 w-6" />
				</template>
				{{ $t('action.save') }}
			</ButtonForm>
		</DialogFooter>
	</DialogContent>
</template>
